
import React from 'react';
import SingleCalendar from './SingleCalendar';

interface CalendarSectionProps {
  title: string;
  displayDate: Date;
  selectedDate: Date | null;
  onDaySelect: (day: number) => void;
  onNavigate: (direction: 'prev' | 'next') => void;
  isStartCalendar: boolean;
  startDate: Date | null;
}

const CalendarSection: React.FC<CalendarSectionProps> = ({
  title,
  displayDate,
  selectedDate,
  onDaySelect,
  onNavigate,
  isStartCalendar,
  startDate
}) => {
  return (
    <div className="space-y-2">
      <h3 className="font-medium mb-2 text-center text-primary-light text-base">{title}</h3>
      <SingleCalendar 
        displayDate={displayDate} 
        selectedDate={selectedDate} 
        onDaySelect={onDaySelect} 
        onNavigate={onNavigate} 
        isStartCalendar={isStartCalendar} 
        startDate={startDate} 
      />
    </div>
  );
};

export default CalendarSection;
